const API_URL = process.env.NODE_ENV === 'production' 
  ? 'https://ama-europe-backend.vercel.app'
  : 'http://localhost:5000';

export const fetchWithRetry = async (url, options, retries = 3) => {
  try {
    const response = await fetch(url, options);
    if (!response.ok) throw new Error(response.statusText);
    return response;
  } catch (error) {
    if (retries > 0) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      return fetchWithRetry(url, options, retries - 1);
    }
    throw error;
  }
};

export default API_URL;